import { gql } from '@apollo/client';

export const COMPLIANCE = gql`
  fragment compliance on Compliance {
    id
    type
    title
    description
    imageUrl
  }
`;

// export const EUDR_BASE_STATEMENT = gql`
//   fragment eudrBaseStatementValues on EUDRStatement {
//     id
//     title
//     createdTimestamp
//     modifiedTimestamp
//     year
//     status
//     companyResponsibilityType
//     companyAffectednessType
//     aggregatedQuestionnaires {
//       aggregatedResponseSummary {
//         answered
//         notAnswered
//         total
//       }
//       aggregatedRiskSummary {
//         lowRiskPercentage
//         mediumRiskPercentage
//         highRiskPercentage
//       }
//       requests {
//         ...partnerRequestValues
//       }
//     }
//   }
//   ${PARTNER_REQUEST_FRAGMENT}
// `;

// export const EUDR_STATEMENT = gql`
//   fragment eudrStatementValues on EUDRStatement {
//     ...eudrBaseStatementValues
//     involvedPartnerCompanies {
//       id
//     }
//     datasets {
//       ...datasetValues
//       cultivatedAreas {
//         ...cultivatedAreaValues
//       }
//       tableRepresentation {
//         ...datasetTableRepresentationValues
//       }
//     }
//   }
//   ${EUDR_BASE_STATEMENT}
//   ${CULTIVATED_AREAS_FRAGMENT}
//   ${DATASET_FRAGMENT}
//   ${DATASET_TABLE_REPRESENTATION_FRAGMENT}
// `;

// export const QUESTIONNAIRE_RESPONSE_OPTION_FRAGMENT = gql`
//   fragment questionnaireResponseOptionValues on QuestionnaireResponsesOptions {
//     id
//     text
//     weight
//     riskLevel
//     answerPercentage
//   }
// `;
